define('Store.HandlebarsHelper.EntryPoint', [
    'Store.HandlebarsHelper.StoreBasedCMSArea'
], function HandlebarsHelper() {
    'use strict';
});
